// Registers src/service-worker.js (emitted by the CRA build as /service-worker.js).
// Production builds only: in development the worker would intercept the dev server's navigations.
export function register() {
    if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return

    window.addEventListener('load', () => {
        navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`).catch((error) => {
            // Non-fatal: without a worker the app works exactly as before, minus the offline page.
            console.warn('Service worker registration failed:', error)
        })
    })
}

// Kill switch: call this instead of register() and deploy to remove the worker from every browser.
export function unregister() {
    if (!('serviceWorker' in navigator)) return

    navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
        .catch((error) => console.warn('Service worker unregister failed:', error))
}
